const getCookie = (name: string): string | null => {
  const value = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return value ? value.pop() ?? null : null;
};

const setCookie = (name: string, value: string, domain?: string, days = 30) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=${domain}`;
};

export { getCookie, setCookie };
